import classNames from 'classnames';
import { forwardRef, useState } from 'react';
import { IMAGES } from '~/assets/assetsPath';
import styles from './Image.module.scss';

const Image = forwardRef(
    ({ src, alt, className, fallback: customFallback = IMAGES.ImagePlaceholder, ...props }, ref) => {
        const [fallback, setFallback] = useState('');

        const handleError = () => {
            setFallback(customFallback);
        };

        return (
            <img
                className={classNames(styles.wrapper, className)}
                ref={ref}
                src={fallback || src}
                alt={alt}
                {...props}
                onError={handleError}
            />
        );
    },
);

export default Image;
